import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import './global.css';

import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { routes } from 'src/routes/sections';
import { ThemeProvider } from 'src/theme';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsProvider } from 'src/context/theme-settings-context';
import { SnackbarProvider } from 'src/context/snackbar-context';

// import i18n instance (needs to be bundled ;))
import './i18n/i18n';

const router = createBrowserRouter(routes);
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SettingsProvider defaultSettings={{ themeLayout: 'default', themeMode: 'light' }}>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MotionLazy>
              <SnackbarProvider>
                <RouterProvider router={router} />
              </SnackbarProvider>
            </MotionLazy>
          </LocalizationProvider>
        </ThemeProvider>
      </SettingsProvider>
    </QueryClientProvider>
  );
}

export default App;
